import React from 'react'
import { l } from '@manychat/manyui'

import { Prompt } from 'common/core/interfaces/prompt'
import { analyticsService } from 'utils/services/analytics'

export const getPrompt = (onActivateBraze: VoidFunction): Prompt => {
  const handleConfirm = () => {
    analyticsService.sendEvent('APP.ACTION_TOAST_BRAZE.CLICK_ACCEPT')
    onActivateBraze()
  }
  const handleClose = () => {
    analyticsService.sendEvent('APP.ACTION_TOAST_BRAZE.CLICK_LATER')
  }

  return {
    id: 'braze_cookie_prompt',
    title: <h1>{l.translate('We changed communication platform')}</h1>,
    content: (
      <p className="m-t-0">
        {l.translate(
          "We switched from Intercom to Braze but your experience won't change. We just need to add Braze to your accepted cookies so you continue getting our messages.",
        )}
      </p>
    ),
    close: {
      onClick: handleClose,
      text: l.translate('Maybe later'),
    },
    confirm: {
      onClick: handleConfirm,
      text: l.translate("Yes, that's fine"),
    },
    unmountEvent: 'APP.ACTION_TOAST_BRAZE.CLOSED',
    mountEvent: 'APP.ACTION_TOAST_BRAZE.SHOWN',
  }
}
